import { render } from "./PricesManager.vue?vue&type=template&id=b3023282"
import script from "./PricesManager.vue?vue&type=script&lang=js"
export * from "./PricesManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__